import { Fragment } from 'react';
import { Provider } from 'react-redux';

import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { store } from './redux/store';
import { ClothesShop } from './views/ClothesShop';
import { Background } from './components/Background';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<Background />
			<ClothesShop />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.ClothesShop)
	.build();

export default Layout;
